<template>
    <b-dropdown
        :text="initials"
        class="avatar"
        :title="`Angemeldet als ${user.username}`"
    >
        <b-dropdown-item @click="$router.push({ name: 'PasswordReset' })">Passwort ändern</b-dropdown-item>
        <b-dropdown-item @click="onLogout">Abmelden</b-dropdown-item>
    </b-dropdown>
</template>

<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue'


export default {
    name: 'AvatarMenu',

    components: { BDropdown, BDropdownItem },

    data: () => ({
        showMenu: false,
    }),

    computed: {
        user () {
            return { username: 'Nick' }
        },

        initials () {
            return this.user.username.charAt(0)
        },
    },

    methods: {
        onLogout () {
            this.$store.dispatch('logout')
            this.$router.push({ name: 'Login' })
        },
    },
}
</script>

<style lang="scss" scoped>
$avatar-size: 45px;

.avatar /deep/ .btn {
    background: $primary-color !important;
    color: $white;
    border: none;
    border-radius: $border-radius-round;
    width: $avatar-size;
    height: $avatar-size;
    display: block;

    &:after {
        display: none !important;
    }
}
</style>
